export default theme => ({
    statColumns: {
        position: 'relative',
        marginBottom: 36,
        padding: '80px 0 120px',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: '50%',
            width: '100vw',
            transform: 'translateX(-50vw)',
            backgroundColor: theme.palette.secondary.main,
        },
        '& *': {
            color: theme.palette.secondary.contrastText,
            position: 'relative',
            zIndex: '1',
        },
        '& h2': {
            fontSize: 24,
            [theme.breakpoints.up('md')]: {
                fontSize: 32,
            }
        },
        '& p': {
            letterSpacing: '0.032em',
            fontSize: 16,
            lineHeight: 2,
            width: 260,
            marginRight: 24,
            float: 'left',
            [theme.breakpoints.up('md')]: {
                width: 210,
            }
        }
    },
    statColumnsTheme: {
        ...theme.statColumnsTheme,
    }
})